import { render } from "./ManagerCompanyRecordsView.vue?vue&type=template&id=e3d3805a"
import script from "./ManagerCompanyRecordsView.vue?vue&type=script&lang=js"
export * from "./ManagerCompanyRecordsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__